<template>
  <div class="dictionary-container">
    <el-input
      v-model="SchoolYear"
      size="small"
      :placeholder="$t('app.bedTags.schoolYear')"
      style="width: 200px; margin-right: 20px"
    ></el-input>
    <!-- <el-input
      v-model="name"
      size="small"
      :placeholder="$t('app.bedTags.name')"
      style="width: 200px; margin-right: 20px"
    ></el-input> -->
    <el-select
      v-model="isUse"
      size="small"
      style="width: 200px; margin-right: 20px"
      :placeholder="$t('app.validation.select') + $t('app.enable')"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button
      type="primary"
      size="small"
      icon="el-icon-search"
      @click="getList()"
    ></el-button>
    <el-button
      type="primary"
      size="small"
      icon="el-icon-plus"
      @click="handleNew()"
      >{{ $t("app.new") }}</el-button
    >
    <el-table :data="tableData" stripe style="width: 100%">
      <!-- <el-table-column align="left" :label="$t('app.serialNumber')" prop="code">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column> -->

      <template v-for="col in column">
        <el-table-column
          :key="col.model"
          align="center"
          :label="col.label"
          :prop="col.model"
        >
          <template slot-scope="scope">
            <template>
              {{ scope.row[col.model] }}
            </template>
          </template>
        </el-table-column>
      </template>

      <el-table-column align="center" width="300" :label="$t('app.operation')">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
            >{{ $t("app.edit") }}</el-button
          >
          <el-button type="danger" size="small" @click="handleDel(scope.row)">{{
            $t("app.delete")
          }}</el-button>
          <el-button size="small" type="success" @click="bedTagsItem(scope.row)"
            >標籤項</el-button
          >
          <el-button size="small" type="success" @click="copyItem(scope.row)"
            >複製</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <el-dialog
      :title="$t('app.delete')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ $t("app.isDelete") + "(" + deleteItem + ")" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="deleteBedTags()"
          >{{ $t("app.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <BedTags-modal ref="bedTagsModal" @handleSuccess="getList"></BedTags-modal>
    <BedTags-item ref="bedTagsItem"></BedTags-item>
  </div>
</template>

<script>
import BedTagsModal from "./modules/BedTagsModal";
import BedTagsItem from "./modules/BedTagsItem";
import {
  getPageList,
  del,
  CopyTags
} from "@/api/systemManagement/bedTagsManagement";
import { delEmpty } from "@/utils/utils";
export default {
  components: {
    BedTagsModal,
    BedTagsItem
  },
  data() {
    return {
      column: [
        { model: "SchoolYear", label: this.$t("app.bedTags.schoolYear") },
        { model: "enable", label: this.$t("app.bedTags.enable") },
        { model: "Description", label: this.$t("app.bedTags.description") }
      ],
      Id: "",
      Pid: "",
      SchoolYear: "",
      Code: "",
      Name: "",
      isUse: null,
      options: [
        {
          value: true,
          label: this.$t("app.isUse")
        },
        {
          value: false,
          label: this.$t("app.disable")
        }
      ],
      size: 10,
      currentPage: 1,
      total: 100,
      loading: false,
      dialogVisible: false,
      tableData: [],
      rowInfo: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getPageList(
        delEmpty({
          SchoolYear: this.SchoolYear,
          Code: this.Code,
          Name: this.Name,
          IsUse: this.isUse,
          PageIndex: this.currentPage,
          PageSize: this.size
        })
      ).then(res => {
        this.total = res.data.Total;
        if (this.total == 0) {
          this.tableData = [];
        } else {
          this.tableData = res.data.Items.map(item => {
            return {
              SchoolYear: item.SchoolYear,
              Code: item.Code,
              Name: item.Name,
              enable: "true" == item.IsUse ? true : false,
              Id: item.Id,
              Pid: item.Pid,
              Description: item.Description
            };
          });
        }
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    // 编辑
    handleEdit(index, row) {
      this.$refs.bedTagsModal.edit(index, row);
    },
    // 输出
    handleDel(row) {
      this.rowInfo = row;
      this.dialogVisible = true;
      this.deleteItem = row.code;
      this.deleteItemType = row.typeCode;
    },
    // 新增
    handleNew() {
      this.$refs.bedTagsModal.add();
    },
    // 复制
    copyItem(row) {
      this.$confirm(this.$t("app.bedTags.confirmModification")).then(() => {
        try {
          console.log("row.Id: " + row.Id);
          CopyTags({
            SchoolYear: row.SchoolYear,
            Code: row.Code,
            Name: row.Name,
            SourceId: row.Id
          }).then(() => {
            this.$message({
              message: "复制成功",
              type: "success"
            });
            this.getList();
          });
        } catch (err) {
          this.$message({
            message: err,
            type: "error"
          });
        }
      });
    },
    bedTagsItem(row) {
      this.$refs.bedTagsItem.visible(row);
    },
    deleteBedTags() {
      del({
        id: this.rowInfo.Id
      }).then(() => {
        this.$message({
          message: this.$t("app.opeSuccess"),
          type: "success"
        });
        this.dialogVisible = false;
        this.getList();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dictionary-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
</style>
